import { BRANDSETTINGS } from "constants/action-types";
import { handleActions } from "redux-actions";
import { initialBaseState, updateProgressActions } from "./base-reducers";

export const brandSettingsImageFormats = handleActions(
    {
        ...updateProgressActions(BRANDSETTINGS.IMAGE_FORMATS.UPDATE),
    } as any,
    initialBaseState
);
